import React from "react";

import { Button } from "antd";

import { ProductEventProps, goTo, productAnalytics, trackMixpanel, useNavigate } from "utils";

import { Icon, Typography } from "components";

type IconLinkButtonProps = ProductEventProps & {
  className?: string;
  dataTestId?: string;
  disabled?: boolean;
  href?: string;
  iconName?: string;
  iconType?: "info" | "arrow" | "logout";
  mixpanelText?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  size?: "small" | "large";
  text?: string;
  // TODO: review which themes are needed
  theme?: "grey" | "light" | "grey-small" | "black-grey-bold";
};

export const IconLinkButton = ({
  className,
  dataTestId,
  disabled,
  href,
  iconName = "info",
  iconType,
  mixpanelText,
  productEvent,
  productEventProperties,
  onClick,
  size,
  text,
  theme,
}: IconLinkButtonProps) => {
  const navigate = useNavigate();

  const getIconSize = () => {
    if (size === "small") return "s";
    if (size === "large") return undefined;
    return "s";
  };

  const getIcon = () => {
    switch (iconType) {
      case "info":
        return <Icon iconName="tabler/info-circle" className="icon inline" size={getIconSize()} />;
      case "arrow":
        return <Icon iconName="tabler/arrow-narrow-right" className="icon inline" size={getIconSize()} />;
      case "logout":
        return <Icon iconName="tabler/logout" className="icon inline" size={getIconSize()} />;
      default:
        return <Icon iconName={iconName} className="icon inline" />;
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    trackMixpanel("ClickLink", {
      linkText: mixpanelText || text || "undefined",
    });
    if (productEvent) productAnalytics.track(productEvent, productEventProperties);
    if (href) {
      goTo(e, navigate, href);
    }
    onClick?.(e);
  };

  return (
    <Button className={`${theme} ${className}`} data-testid={dataTestId} type="link" disabled={disabled} onClick={handleClick} size={size}>
      <Typography variant="paragraph-m">
        {text} {getIcon()}
      </Typography>
    </Button>
  );
};
